import Vue from 'vue'
import customSelect from "./custom-select"

Vue.component('custom-select', customSelect)


// WEBPACK FOOTER //
// ./src/components/index.js